

































import { nanoid } from 'nanoid';
import Vue from 'vue';

import { WithRefs } from 'vue-typed-refs';

type Refs = {
  input: HTMLInputElement;
};

export default (Vue as WithRefs<Refs>).extend({
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    uuid: {
      type: String,
      default() {
        return nanoid();
      },
    },
    checked: {
      type: Boolean,
    },
    indeterminate: {
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    hideLabel: {
      type: Boolean,
    },
  },
  computed: {
    // eslint-disable-next-line @typescript-eslint/ban-types
    inputListeners(): Record<string, Function | Function[]> {
      return {
        ...this.$listeners,
        change: (event: InputEvent) => {
          event.preventDefault();
          const target = event.target as HTMLInputElement;
          this.$emit('change', (target as HTMLInputElement).checked);
          // see https://github.com/vuejs/vue/issues/9535
          target.checked = !target.checked;
        },
      };
    },
  },
  watch: {
    indeterminate() {
      this.$refs.input.checked = false;
    },
  },
  methods: {
    /** Firefox doesn't emit a click event on `<label>` element when Shift is pressed */
    onMouseUp(e: MouseEvent) {
      if (e.shiftKey) {
        const isFirefox =
          navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

        if (isFirefox) {
          this.$emit('change', !this.checked);
        }
      }
    },
    onSelectStart(e: Event) {
      if (this.hideLabel) {
        e.preventDefault();
      }
    },
  },
});
